var _excluded = ["type", "children", "prefix", "state", "className", "cols"];

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { RangeState } from '../../../hooks/date';
import { classnames } from '@okee-uikit/react-utils';
import React from 'react';
import { usePrefixCls } from '@okee-uikit/react-config';
import { useDateState } from '../hooks/useDateState';
export function ViewRow(props) {
  var type = props.type,
      children = props.children,
      prefix = props.prefix,
      _props$state = props.state,
      state = _props$state === void 0 ? {} : _props$state,
      className = props.className,
      _props$cols = props.cols,
      cols = _props$cols === void 0 ? [] : _props$cols,
      extra = _objectWithoutProperties(props, _excluded);

  var _state$disabledState = state.disabledState,
      disabledState = _state$disabledState === void 0 ? RangeState.NONE : _state$disabledState,
      _state$selectedState = state.selectedState,
      selectedState = _state$selectedState === void 0 ? RangeState.NONE : _state$selectedState,
      _state$tryingSelected = state.tryingSelectedState,
      tryingSelectedState = _state$tryingSelected === void 0 ? RangeState.NONE : _state$tryingSelected;
  var rowCls = classnames(usePrefixCls(prefix, _defineProperty({
    row: true
  }, type, true), true), useDateState(prefix, state), className);

  if (type === 'week') {
    var selectedType = selectedState === RangeState.SINGLE || selectedState === RangeState.END || selectedState === RangeState.START ? 'selected' : selectedState === RangeState.IN ? 'selected-in' : false;
    var selectedViews = selectedType ? calcRowSelected(cols, selectedType, true) : [];
    var tryingType = tryingSelectedState !== RangeState.NONE ? 'trying' : false;
    var disabledType = disabledState !== RangeState.NONE ? 'disabled' : false;
    return React.createElement("div", _objectSpread({
      className: rowCls
    }, extra), !selectedType && React.createElement(ViewRowRanger, {
      start: 0,
      end: 0,
      total: 7,
      type: "hover"
    }), selectedType && selectedViews.map(function (item, index) {
      return React.createElement(ViewRowRanger, _objectSpread(_objectSpread({}, item), {}, {
        key: index,
        type: selectedType
      }));
    }), tryingType && React.createElement(ViewRowRanger, {
      start: 0,
      end: 0,
      total: 7,
      type: "trying"
    }), disabledType && React.createElement(ViewRowRanger, {
      start: 0,
      end: 0,
      total: 7,
      type: "disabled"
    }), children);
  }

  var views = [].concat(_toConsumableArray(calcRowSelected(cols, 'selected', true)), _toConsumableArray(calcRowSelected(cols, 'trying', true)), _toConsumableArray(calcRowSelected(cols, 'disabled', false)));
  return React.createElement("div", _objectSpread({
    className: rowCls
  }, extra), views.map(function (item, index) {
    return React.createElement(ViewRowRanger, _objectSpread(_objectSpread({}, item), {}, {
      key: index
    }));
  }), children);
}
export function ViewRowRanger(props) {
  var _usePrefixCls2;

  var start = props.start,
      end = props.end,
      total = props.total,
      type = props.type;
  var cls = usePrefixCls('date', (_usePrefixCls2 = {}, _defineProperty(_usePrefixCls2, 'left' + start, true), _defineProperty(_usePrefixCls2, 'right' + end, true), _defineProperty(_usePrefixCls2, "row", type), _usePrefixCls2));

  if (start + end > total - 1) {
    return null;
  }

  return React.createElement("div", {
    className: cls
  });
}
export function calcRowSelected(cols, type, ignoreOutRange) {
  var result = [];
  var total = cols.length;
  var inRange = false;
  var start = total;
  var end = total;

  for (var i = 0; i < total; i++) {
    var _cols$i = cols[i],
        tryingSelectedState = _cols$i.tryingSelectedState,
        selectedState = _cols$i.selectedState,
        disabledState = _cols$i.disabledState,
        gridState = _cols$i.gridState;
    var state = type === 'selected' ? selectedState : type === 'trying' ? tryingSelectedState : disabledState;

    if (ignoreOutRange && (gridState === RangeState.PREV || gridState === RangeState.NEXT)) {
      if (inRange) {
        end = total - i;
        inRange = false;
        result.push({
          total: total,
          start: start,
          end: end,
          type: type
        });
      }

      continue;
    }

    if (state === RangeState.IN || state === RangeState.START) {
      if (!inRange) {
        start = i;
        inRange = true;
      }
    }

    if (state === RangeState.END) {
      end = total - i - 1;

      if (!inRange) {
        result.push({
          total: total,
          start: i,
          end: end,
          type: type
        });
      } else {
        inRange = false;
        result.push({
          total: total,
          start: start,
          end: end,
          type: type
        });
      }
    }
  }

  if (inRange) {
    end = 0;
    result.push({
      total: total,
      start: start,
      end: end,
      type: type
    });
  }

  return result;
}